"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var LogoAndName_1 = __importDefault(require("atomicComponents/molecules/Image/LogoAndName"));
var Header = function (_a) {
    var brand = _a.brand, companyName = _a.companyName;
    return ((0, jsx_runtime_1.jsx)(material_1.Box, __assign({ position: "sticky", top: 0, bgcolor: "white", zIndex: 3 }, { children: (0, jsx_runtime_1.jsxs)(material_1.Stack, __assign({ direction: "row", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid #B6C5CD", px: 3, py: 2.5 }, { children: [(0, jsx_runtime_1.jsx)(LogoAndName_1.default, { fontWeight: "medium", brand: brand !== null && brand !== void 0 ? brand : { name: companyName !== null && companyName !== void 0 ? companyName : '', logoUrl: '/tool-placeholder.svg' } }), (0, jsx_runtime_1.jsx)("img", { src: "/rechargly-logo.svg", alt: "Rechargly Logo", height: 20 })] })) })));
};
exports.default = Header;
